const digest = '24130534885171d8584923b34fa99b2e7efeb095b2c8c6a18fad1e3fed6ceaa7';
const css = `._stepperRow_rqmh3_1>div{align-items:end}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'stepperRow': '_stepperRow_rqmh3_1' };
export const stepperRow = '_stepperRow_rqmh3_1';
export { css, digest };